import Ports from '../../models/Ports';
import { RECEIVE_ORIGIN_PORTS } from '../actions/actionTypes';

const initialState: Ports = {}

export const originPortsReducer = (state: Ports = initialState, action: any) => {
  switch (action.type) {
    case RECEIVE_ORIGIN_PORTS:
      return {...action.data};
    default:
     return state
  }

};
